import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Company extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            password: '',
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/profile/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/profile/save", {
            fname: this.state.data.record.fname,
            lname: this.state.data.record.lname,
            password: this.state.password
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت بروز رسانی شد");
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="container">
            <div className="panel panel-info center-block">
                <div className="panel-heading">
                    <span className="panel-title acc-txt-9"><strong>تنظیمات حساب کاربری</strong></span>
                </div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label for="inputFinanYearName" className="title1">نام <span className="red">*</span></label>
                                <input defaultValue={this.state.data.record.fname} onChange={e => this.state.data.record.fname = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label for="inputFinanYearName" className="title1">نام خانوادگی <span className="red">*</span></label>
                                <input defaultValue={this.state.data.record.lname} onChange={e => this.state.data.record.lname = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group">
                                <label for="inputFinanYearName" className="title1">کلمه عبور <span className="red">*</span></label>
                                <input defaultValue={this.state.password} onChange={e => this.state.password = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                <span>جهت عدم تغییر کلمه عبور این فیلد را خالی قرار دهید</span>
                            </div>
                        </div>
                    </div>
                    <div style={{ "margin-bottom": "20px" }} ></div>
                    <div className="panel panel-default center-block iransans" style={{ "font-size": "12pt", "background-color": "whitesmoke", "padding": "10px" }}>
                        <div className="row">
                            <div className="col-xs-2">
                                <button onClick={e => this.save(e)} className="btn btn-success">ذخیره</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}